/* Prevents the scroll-up header from surfacing at the bottom of the page: a
   reflow (infinite scroll) lowers scrollTop, which Horizon reads as a scroll-up.
   The header is only revealed on a genuine upward gesture (wheel / touch). */
(function () {
  var header = document.querySelector('header-component');
  if (!header || header.getAttribute('sticky') !== 'scroll-up') return;

  var dir = 0; // 1 = downward gesture, -1 = upward, 0 = none
  var lastY = null;

  /* Near the top, the header is static in the flow but the state machine can
     stay 'idle' (vendor opacity 0) after a fast scroll back up, leaving a white
     band where the header should be. data-bq-at-top forces its visibility (CSS
     in bq-motion). Same container logic as scroll-container.js (squeeze:
     .page-wrapper scrolls on desktop). */
  var squeeze = window.matchMedia('(min-width: 990px)');
  function scroller() {
    return (squeeze.matches && document.querySelector('.page-wrapper')) ||
      document.scrollingElement || document.documentElement;
  }
  function scrollTarget() {
    return (squeeze.matches && document.querySelector('.page-wrapper')) || document;
  }
  var atTopTicking = false;
  function syncAtTop() {
    atTopTicking = false;
    if (scroller().scrollTop < 80) header.setAttribute('data-bq-at-top', '');
    else header.removeAttribute('data-bq-at-top');
  }
  function onScrollAtTop() {
    if (atTopTicking) return;
    atTopTicking = true;
    requestAnimationFrame(syncAtTop);
  }
  var boundScroller = null;
  function bindAtTop() {
    if (boundScroller) boundScroller.removeEventListener('scroll', onScrollAtTop);
    boundScroller = scrollTarget();
    boundScroller.addEventListener('scroll', onScrollAtTop, { passive: true });
    syncAtTop();
  }
  bindAtTop();
  squeeze.addEventListener('change', bindAtTop);

  addEventListener('wheel', function (e) {
    if (e.deltaY) dir = e.deltaY > 0 ? 1 : -1;
  }, { passive: true, capture: true });

  addEventListener('touchstart', function (e) {
    lastY = (e.touches && e.touches[0]) ? e.touches[0].clientY : null;
  }, { passive: true, capture: true });

  addEventListener('touchmove', function (e) {
    if (lastY == null || !e.touches || !e.touches[0]) return;
    var y = e.touches[0].clientY;
    if (y < lastY) dir = 1;        // finger up => page scrolls down
    else if (y > lastY) dir = -1;  // finger down => page scrolls up
    lastY = y;
  }, { passive: true, capture: true });

  new MutationObserver(function () {
    if (header.dataset.stickyState !== 'active' || dir < 0) return;
    // Reveal without a genuine scroll-up: cancelled instantly.
    var prev = header.style.transition;
    header.style.transition = 'none';
    header.dataset.stickyState = 'idle';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { header.style.transition = prev; });
    });
  }).observe(header, { attributes: true, attributeFilter: ['data-sticky-state'] });
})();
